import { useRef } from 'react'

export function Credits() {
  const dialog = useRef<HTMLDialogElement>(null)
  return <>
    <button type="button" className="pg-link pg-credits-button" onClick={() => dialog.current?.showModal()}>Credits</button>
    <dialog ref={dialog} className="pg-credits" aria-labelledby="credits-title">
      <header><h2 id="credits-title">Credits</h2><button type="button" className="tt-icon-button" aria-label="Close credits" data-ui-sound="cancel" onClick={() => dialog.current?.close()}>×</button></header>
      <h3>Sound design</h3>
      <p>Sounds by <a href="https://jdsherbert.itch.io/" target="_blank" rel="noreferrer">JDSherbert</a>.</p>
      <ul><li>Wooden UI SFX Pack — interface sounds</li><li>Tabletop Games SFX Pack — game pieces</li></ul>
      <p className="pg-muted">Copyright © 2025 JDSherbert. All rights reserved. Used under license.</p>
      <p>Card sounds by <a href="https://kenney.nl/assets/casino-audio" target="_blank" rel="noreferrer">Kenney</a> — Casino Audio, licensed <a href="https://creativecommons.org/publicdomain/zero/1.0/" target="_blank" rel="noreferrer">CC0 1.0</a>.</p>
    </dialog>
  </>
}
